/**
 * @description
 */

import './sectionResultItem.scss';

import React, { Component } from 'react';

// tslint:disable:ordered-imports
import SectionResultItemHeader from '../@sectionResultItemHeader/sectionResultItemHeader';
import SectionRadioboxResultList from './sectionTypes/@sectionRadioboxResultList/sectionRadioboxResultList';
import SectionCheckboxResultList from './sectionTypes/@sectionCheckboxResultList/sectionCheckboxResultList';
import SectionTextareaResultList from './sectionTypes/@sectionTextareaResultList/sectionTextareaResultList';
import SectionNumberResultList from './sectionTypes/@sectionNumberResultList/sectionNumberResultList';
import SectionParagraph from '../../@sectionParagraph/sectionParagraph';
import { ESurveySectionType, ISurveySectionInfo } from '@umu/umu-types';

export interface IProps {
    key: number;
    sectionInfo: ISurveySectionInfo;
    parentId?: number;
    objId?: number;
}

export default class SectionItem extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public renderSectionHeader() {
        const { sectionInfo } = this.props;
        const { type } = sectionInfo;
        if (type === ESurveySectionType.PARAGRAPH) {
            return null;
        }

        return <SectionResultItemHeader sectionInfo={sectionInfo} />;
    }

    public renderSectionBody() {
        const { sectionInfo, parentId, objId } = this.props;
        const { type } = sectionInfo;

        const questionMap: any = {
            [ESurveySectionType.PARAGRAPH]: SectionParagraph,
            [ESurveySectionType.RADIO]: SectionRadioboxResultList,
            [ESurveySectionType.CHECKBOX]: SectionCheckboxResultList,
            [ESurveySectionType.TEXTAREA]: SectionTextareaResultList,
            [ESurveySectionType.NUMBER]: SectionNumberResultList,
        };

        const questionSection = questionMap[type];
        if (!questionSection) {
            return null;
        }

        return React.createElement(questionSection, {
            sectionInfo,
            parentId,
            objId,
        });
    }

    public render() {
        return (
            <div className="section-result-item">
                {this.renderSectionHeader()}
                {this.renderSectionBody()}
            </div>
        );
    }
}
